import { ITenantConfig } from '../tenant.interface';

export const DOQFY_TENANT: ITenantConfig = {
  id: 'DOQFY',
  displayName: 'Doqfy',
  logo: 'assets/logos/doqfy_logo.png',
  favicon: 'assets/logos/small_logo.png',
  theme: {
    primaryColor:  '#612E86',
    primaryDark:   '#4a2165',
    secondaryColor: '#2a2a2a',
    accentColor:   '#f5a623',
    fontFamily:    '"Poppins", sans-serif',
    logoUrl:       'assets/img/new-logo.png',
    logoHeight:    '35px',
  },
  auth: {
    type: 'standard',
    msalClientId: 'd443367d-5b91-4695-8525-f3ad63cfc3c0',
  },
  features: {
    estamp: true,
    esign: true,
    inventory: true,
    bulkUpload: true,
    reports: true,
    preProcurement: true,
    walletManagement: true,
    userManagement: true,
    catExecution: true,
  },
  domains: ['doqfy.in', 'localhost'],
};
